import { Form, Input } from "antd";

import "./Filters.css"

export interface FilterStringProps{
    onChange?:(value:string)=>void
    className?:React.HTMLAttributes<HTMLDivElement>['className'];
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
    forceUpperCase?:boolean
}

export function FilterString(props:FilterStringProps){
    const rules=[{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]

    function onChange(value:any){
        if(props?.onChange){
            props?.onChange(value.target.value)
        }
    }

    const className = "filter " + (props?.className ?? "");

    return  <>
        <Form.Item name={props.dataKey}
                   label={props.label}
                   rules={rules}
        >
            <Input className={className} placeholder={props.placeholder}
                   onInput={(e: React.FormEvent<HTMLInputElement>) => {
                       if (props.forceUpperCase) {
                           e.currentTarget.value = e.currentTarget.value.toUpperCase();
                       }
                   }}
                   onChange={onChange} allowClear={true}/>
        </Form.Item>
    </>

}